import styled from 'styled-components';
import { Container } from 'styles';
import { Icon, Text } from '@perch-labs/shrike';

export const Wrapper = styled(Container).attrs({
  direction: 'column',
  flex: true,
})`
  background: ${props => props.theme.colors.background[props.backgroundColor]};
  padding: 24px 24px 0;
  border-radius: ${props => props.theme.borderRadii.large};
`;

export const IconContainer = styled(Container).attrs({
  alignItems: 'center',
  direction: 'column',
  flex: true,
  flexGrow: 0,
})``;

export const ContentContainer = styled(Container).attrs({
  direction: 'column',
  flex: true,
  margin: { bottom: '24px', left: '24px' },
})``;

export const CheckmarkIcon = styled(Icon).attrs(({ margin }) => ({
  icon: 'CheckmarkCircleInverted',
  margin: margin || { bottom: '8px' },
  size: 500,
}))``;

export const ExclamationIcon = styled(Icon).attrs({
  icon: 'ExclamationCircleInverted',
  margin: { bottom: '8px' },
  size: '500',
})``;

export const StyledText = styled(Text).attrs((props: StyleProps) => ({
  margin: props.active ? { bottom: '8px' } : { top: '2px' },
  opacity: props.active ? 'high' : 'medium',
  tag: 'p',
  textStyle: 'heading500',
}))<StyleProps>``;

export const VerticalBar = styled.div`
  flex-grow: 1;
  border-left: ${props =>
    `1px solid ${props.theme.colors.background.tertiary}`};
  border-right: ${props =>
    `1px solid ${props.theme.colors.background.tertiary}`};
  width: 0;
`;

export const Donut = styled.div`
  border-radius: 50%;
  border: ${props => `2px solid ${props.theme.colors.content.primary}`};
  opacity: ${props => props.theme.opacities.low};
  height: 8px;
  width: 8px;
  margin: 8px 4px;
`;
